module.exports = __webpack_public_path__ + "static/media/rodz.71d9ebfb.jpg";